import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator';
import {namespace} from 'vuex-class';
import {SEARCH_AUTOCOMPLETE, SEARCH_MODULE_NAMESPACE} from '../../../../store/search';
import {BLOCK_GET_BLOCKS, BLOCK_MODULE_NAMESPACE, GET_BLOCKS_BY_TETANT} from '../../../../store/block';
import {IBlock, IBlockParameter} from '../../../../models/block';
import {
  APARTMENT_GET_APPARTMENTS_AUTOCOMPLETE,
  APARTMENT_GET_BLOCK_APPARTMENTS_AUTOCOMPLETE,
  APARTMENT_MODULE_NAMESPACE
} from '../../../../store/apartment';
import {ActivityStatus, CrudStatus, SearchEntities} from '../../../../common/enums';
import {USER_MODULE_NAMESPACE} from '../../../../store/user/user-types.store';
import {IUserDetails} from '../../../../models/user';
import {IApartmentListingViewModel} from '../../../../models/apartment';
import * as moment from "moment";
import {Moment} from "moment";
import {BM_EDIT_BM_BY_FIELD, BM_MODULE_NAMESPACE} from "../../../../store/building-monitor/bm-types.store";
import {BMEditedViewModel, IBMDetailViewModel} from "../../../../models/bm";

const SearchStore = namespace(SEARCH_MODULE_NAMESPACE);
const BlockStore = namespace(BLOCK_MODULE_NAMESPACE);
const ApartmentStore = namespace(APARTMENT_MODULE_NAMESPACE);
const UserStore = namespace(USER_MODULE_NAMESPACE);
const BMStore = namespace(BM_MODULE_NAMESPACE)

@Component({
  components: {
  }
})
class TicketModalVertical extends Vue {

  private dtApartments: IApartmentListingViewModel[]
  private dtBlocks: any[]
  private dtExcludeBlock: boolean;
  private dtStep: number;

  private dtApartmentLoading: boolean;
  dtRules: {
    fkBmBlockRules?: any
    fkBmApartmentRules?: any
  }
  bmBlock: number
  bmApartment: number
  sendStartBM: boolean
  sendEndBM: boolean

  constructor() {
    super();
    this.dtRules = {};
    this.dtApartments = [];
    this.dtBlocks = null;
    this.dtApartmentLoading = false;
    this.dtExcludeBlock= false
    this.dtStep = 15
    this.bmBlock = null
    this.bmApartment = null
    this.sendStartBM = false
    this.sendEndBM = false
  }

  @UserStore.Getter userInfo: IUserDetails;
  @UserStore.Getter isTenantAndOwner: boolean;
  @BlockStore.Getter blocks: any[];
  @BlockStore.Getter currentBlock: any;
  @ApartmentStore.Getter apartments: any[];
  @BMStore.Getter bmEdited: BMEditedViewModel;
  @BMStore.Getter bmSource: { activityStatus: ActivityStatus; detail: IBMDetailViewModel };
  @BMStore.Getter bmCrudActionStatus: CrudStatus

  @SearchStore.Action(SEARCH_AUTOCOMPLETE)
  storeGetDeclarants: (payload: { query }) => Promise<any>;
  @BlockStore.Action(BLOCK_GET_BLOCKS)
  storeGetBlocks: (payload: { param: IBlockParameter, merge?: boolean }) => Promise<any>;
  @BlockStore.Action(GET_BLOCKS_BY_TETANT)
  storeGetBlocksByTenantId: (tenantId: number) => Promise<any>;
  @SearchStore.Action(SEARCH_AUTOCOMPLETE)
  storeGetEntitySearch: (payload: {
    entity?: SearchEntities | SearchEntities[], query?: string, limit?: number,
    apartment?: number[], block?: number[]
  }) => Promise<any>;
  @ApartmentStore.Action(APARTMENT_GET_APPARTMENTS_AUTOCOMPLETE)
  storeGetApartmentsAutocomplete: (payload: { blockId?: number, entity?: number[], key?: string, limit?: number }) => Promise<any>;
  @ApartmentStore.Action(APARTMENT_GET_BLOCK_APPARTMENTS_AUTOCOMPLETE)
  storeGetBlockApartmentsAutocomplete: (payload: { blockId?: string, entity?: string, key?: string }) => Promise<any>;

  @BMStore.Mutation(BM_EDIT_BM_BY_FIELD)
  storeSetBMEdited: (payload: { [key: string]: any }) => void

  @Prop({ default: false, type: [Boolean] })
  toUpdate: boolean


  get coDatesStart() {
    return {startDate: this.bmEdited.date_start_building}
  }
  set coDatesStart(dates: { startDate: string | Date | Moment }) {
    this.storeSetBMEdited({
      date_start_building: dates.startDate.toString(),
    })
  }

  get coDatesEnd() {
    return {startDate: this.bmEdited.date_end_building,}
  }
  set coDatesEnd(dates: { startDate: string | Date | Moment }) {
    this.storeSetBMEdited({
      date_end_building: dates.startDate.toString(),
    })
  }

  get coBMBlock() {
    return this.bmEdited.fk_block
  }

  set coBMBlock(block) {
    this.storeSetBMEdited({fk_block: block})
    this.bmBlock = block
  }

  get coBMApartment() {
    return this.bmEdited.fk_apartment
  }

  set coBMApartment(apartment) {
    this.storeSetBMEdited({
      ...this.bmEdited,
      fk_apartment: apartment
    })
    this.bmApartment = apartment
  }


  get lblSetting() {
    return {
      ...require('@/locales/ticket').default,
      ...require('@/locales/building-monitor').default,
      ...require('@/locales/validation-messages').default,
      ...require('@/locales/generic-labels').default,
    }
  }

  get coBlocks() {
    const blocks = (this.dtBlocks || this.blocks || []).map(
      (b: IBlock) => this.mapBlockToOptions(b).next().value);
    return blocks.filter(x => x.value !== undefined);
  }

  get coApartments() {
    return (this.dtApartments || []).map(x => ({
      value: x.apartment.id,
      text: x.apartment['location_number'] ? x.apartment['location_number'] + ' / ' + x.apartment['apartment_number'] : x.apartment['apartment_number'],
      ...x
    }));
  }

  get hadBlock() {
    return typeof this.coBMBlock === "number" && this.coBMBlock > 0
  }

  get isUpdate () {
    return this.bmCrudActionStatus === CrudStatus.Update
  }

  * mapBlockToOptions(block: IBlock) {
    yield {text: block.name, firstname: block.name, lastname: '', value: block.id};
  }

  created() {}

  mounted() {
    this.$nextTick(() => {
      this.storeGetBlocks({param: {}, merge: false}).then()
      this.handleApartmentByBlock().then()
    })
    this.dtRules = {
      fkBmBlockRules: [(v) => (!!v && v > 0) || this.$t(this.lblSetting.blockRequired)],
      fkBmApartmentRules: [(v) => (!!v && v.length > 0) || this.$t(this.lblSetting.apartmentRequired)],
    }
    if (this.isUpdate) {
      if (this.bmSource.detail.date_start_building) {
        this.sendStartBM = true
      }
      if (this.bmSource.detail.date_end_building) {
        this.sendEndBM = true
      }
    }
  }


  async handleChangeBlock(blockId: any) {
    this.handleApartmentByBlock().then()
  }

  async handleChangeApartment(value) {
    if (value) {
      let apartment = (this.dtApartments || []).find(x => x.id === value)
        if (apartment.block.id !== this.coBMBlock) {
          this.coBMBlock = apartment.block.id
          if (this.coBlocks.findIndex(x => x.value === apartment.block.id) === -1) {
            this.dtBlocks = [apartment.block]
          }
        }
    }
  }

  async handleApartmentByBlock() {
    let payload: any = {}
    if (this.coBMBlock)
      payload.blockId = this.coBMBlock
    payload.limit = 50
    this.dtApartmentLoading = true;
    return this.storeGetApartmentsAutocomplete(payload)
      .then(res => {
        this.dtApartments = res.map(x => ({...x, apartment: x}));
        if (this.dtApartments.findIndex(apt => apt.id === this.bmApartment) === -1) {
          this.bmApartment = null
        }
        this.dtApartmentLoading = false;
        return Promise.resolve(res)
      })
      .catch(err => {
        this.dtApartmentLoading = false;
        return Promise.reject(err)
      })
  }

  async handleFetchBlocks(key: string, cb: Function) {
    const param: any = {key};
    return await this.storeGetBlocks({param, merge: false}).then(res => {
      return res.map(x => ({value: x.id, firstname: x.name, lastname: '', text: x.name})) || []
    })
  }

  handleGetApartments(key: string, cb) {
    let payload: any = {key, blockId: null}
    if (this.hadBlock)
      payload.blockId = this.coBMBlock

    this.storeGetApartmentsAutocomplete(payload)
      .then(res => {
        cb((res || []).map(x => ({value: x.id, text: x.apartment_number, ...x})))
      })
      .catch(error => console.log(error))
  }

  changeSwitchStartDate (val) {
    if (val) {
      if (this.isUpdate && this.bmSource.detail.date_start_building) {
        this.coDatesStart = { startDate: this.bmSource.detail.date_start_building }
      } else {
        this.coDatesStart = { startDate: moment().format('YYYY-MM-DDTHH:mm:ss').substring(0, 14)+'00:00.000Z' }
      }
    } else {
      this.coDatesStart = { startDate: '' }
    }
  }

  changeSwitchEndDate (val) {
    if (val) {
      if (this.isUpdate && this.bmSource.detail.date_end_building) {
        this.coDatesEnd = { startDate: this.bmSource.detail.date_end_building }
      } else {
        this.coDatesEnd = { startDate: moment().format('YYYY-MM-DDTHH:mm:ss').substring(0, 14)+'00:00.000Z' }
      }
    } else {
      this.coDatesEnd = { startDate: '' }
    }
  }

}

export default TicketModalVertical;



// WEBPACK FOOTER //
// ./src/containers/building-monitor/components/bm-modal-vertical/index.ts